export default function Social({ onClick, id: buttonId, value, type, socialData, children }) {
	if (!value || !value.length) {
		return false;
	}

	function doOnClick(e) {
		onClick(e, buttonId);
	}

	const url = (socialData.domain ? socialData.domain : '') + value;

	return (
		<a onClick={doOnClick} href={url} className={`btn slp-social-${type}`} title={type}>
			{children}
		</a>
	);
}
